import { Moment } from 'moment';
import { DossierId } from 'src/dossier/models/AbstractDossier';
import User from '@/shared/models/User';
import TestDriveReason from './TestDriveReason';

export interface TestDriveId {__testdriveId: number;}

export default class TestDrive {
  id!: TestDriveId;
  dossierId: DossierId | null = null;
  startTime: Moment | null = null;
  startMileage: number | null = null;
  endTime: Moment | null = null;
  endMileage: number | null = null;
  comment = '';
  createdBy: User | null = null;
  isCustomerPresent = false;
  reason: TestDriveReason | null = null;

  hasEnded(): boolean {
    return this.endTime !== null;
  }

  hasNotEnded(): boolean {
    return this.endTime === null;
  }
}